import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/contact-lp-thanks'
import useLocalStorage from 'hooks/useLocalStorage'

const ContactLpThanks: React.FC = () => {
  // const fromCorrectFormPage = useLocalStorage('refWorkShopLPContactPage')

  return (
    <>
      {/* {fromCorrectFormPage ? ( */}
      <CustomHead
        keyword={
          'Aitria（アイトリア） UX/UI デジタルトランスフォーメーション デザイン思考 デザイン経営 デザインパートナー サービスデザイン クラウドネイティブ'
        }
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/contact-lp-thanks/'}
        title="お問い合わせありがとうございます | Aitria（アイトリア）"
        description=""
        // noindexNofollow={true}
      />
      {/* ) : (
        <></>
      )} */}
      <Template />
    </>
  )
}

export default ContactLpThanks
